export interface StageItem {
  id: string;
  name: string;
  color: string;
  description: string;
  is_system: boolean;
  /** Original ATS stage label — set on ATS import when the Arbi name may diverge. */
  ats_name?: string;
}

export const PICKER_COLORS = [
  "#9f70ff", "#3b82f6", "#06b6d4", "#10b981", "#f59e0b",
  "#f97316", "#ec4899", "#ef4444", "#6366f1", "#84cc16",
];

export function splitStages(stages: StageItem[]) {
  const archived = stages.filter(
    (s) => s.is_system && s.name.toLowerCase() === "archived",
  );
  const nonArchived = stages.filter(
    (s) => !(s.is_system && s.name.toLowerCase() === "archived"),
  );
  const leading = nonArchived.filter((s) => s.is_system);
  const editable = nonArchived.filter((s) => !s.is_system);
  return { leading, editable, trailing: archived };
}
